import React from 'react';
import ReactDOM from 'react-dom';
import './screens/styles/index.css';
import App from './App';
import './screens/styles/fontawesome-free-5.8.1-web/css/all.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as serviceWorker from './serviceWorker';
import {Provider} from 'react-redux';
import Storage from './config/redux/Storage';

ReactDOM.render(<Provider store={Storage}>
                    <App />
                </Provider>, document.getElementById('root'));

                

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

serviceWorker.unregister();
